// extracted by mini-css-extract-plugin
export default {"key":"Key-module__key__G8G92"};